import { DATETIME_FORMAT } from '@/constants';

import { Dayts } from '@/utils';

export const cleanDatetimeRegExp = new RegExp(`[^0-9 /:-]`, 'g');
export const formatDatetime =
  (format: string = DATETIME_FORMAT) =>
  (value: string = ''): string => {
    if (value === '') return '';
    value = value.trim().replace(cleanDatetimeRegExp, '');
    const formattedValue = new Dayts().setDate(value).format(format);
    return formattedValue;
  };
